import $ from 'jquery/dist/jquery.min'
import Chartkick from 'chartkick'
import Chart from 'chart.js'
Chartkick.addAdapter(Chart)

const lineOption = {
  adapter: 'google',
  curve: false,
  points: false,
  min: 0,
  language: 'ja',
  xtitle: '継続期間',
  ytitle: '合計時間（時）',
  library: {
    width: '100%',
    height: 300,
    backgroundColor: 'transparent',
    chartArea: {
      right: 10,
      bottom: 50,
      width: '85%',
      height: '220'
    },
    lineDashStyle: [5, 1],
    hAxis: { format: 'MM/dd' },
    legend: {
      position: 'right',
      alignment: 'center'
    }
  }
}

const pieOption = {
  adapter: 'google',
  language: 'ja',
  xtitle: 'スキル別学習比率',
  library: {
    width: '100%',
    height: 300,
    backgroundColor: 'transparent',
    chartArea: {
      right: 10,
      bottom: 50,
      width: '85%',
      height: '220'
    },
    legend: {
      position: 'right',
      alignment: 'center'
    }
  }
}

$(function () {
  const idName = $('#js-chart-learned-time').data('id')

  $.ajax({
    url: '/api/chart/' + idName + '/portfolio_report.json',
    type: 'GET',
    dataType: 'json'
  }).then((response) => {
    new Chartkick.LineChart('js-chart-learned-time', response.learning_summary, lineOption)
    new Chartkick.PieChart('chart-skill-percentage', response.skill_summary, pieOption)
  }).catch((error) => {
    $('#js-chart-learned-time').before('<p class="text-center">' + error.responseJSON.message + '</p>')
    new Chartkick.LineChart('js-chart-learned-time', error.responseJSON.data)
  })
})
